module.exports = __webpack_public_path__ + "55a651f808fedde314286a00cec23e78.svg";